import { Icon, Tag } from "Components";
import Icons from "Components/Icon/Icons";
import { GET_COLOR_BY_SCORE } from "../CampaignReport.constant";

const PropertyCard = ({ title, desc, iconType, tagValue = null } : { title: string, desc: string, iconType?: keyof typeof Icons, tagValue?: number | null }) => {
    const { bg, color } = tagValue ? GET_COLOR_BY_SCORE(tagValue) : { bg: "#fff", color: "#000"};
    
    return <div className="card">
        <div className="card-content">
            {tagValue ? <Tag style={{ background: bg, color }} className="status-tag">{`${tagValue}%`}</Tag> : iconType && <Icon type={iconType} className={iconType} />}
            <div className={`title ${tagValue ? 'small' : ''}`}>{title}</div>
            <div className="description">{desc}</div>
        </div>
    </div>
}

export default PropertyCard;